import { render } from "./RiverList.vue?vue&type=template&id=b890a3c2&scoped=true"
import script from "./RiverList.vue?vue&type=script&lang=js"
export * from "./RiverList.vue?vue&type=script&lang=js"

import "./RiverList.vue?vue&type=style&index=0&id=b890a3c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b890a3c2"]])

export default __exports__